import Stripe from "stripe";

import { sendRequest } from "../clients/axios";

interface RenewSubscriptionInput {
  renew: boolean;
}

export const renewSubscription = async (renew: boolean) => {
  const res = await sendRequest<
    RenewSubscriptionInput,
    Stripe.Response<Stripe.Subscription>
  >({
    method: "post",
    url: "/subscription/renew-subscription",
    data: { renew },
  });
  return res.data;
};
